// extracted by mini-css-extract-plugin
export default {"Users":"Users_Users__6vNkp","Users__new":"Users_Users__new__69a-8"};